import styled, { css } from 'styled-components';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import styles
import { customMinResponsive, size } from 'components/styles';

export const ButtonWrapper = styled.div<{ withPadding?: boolean }>`
	position: absolute;
	align-self: flex-end;
	width: auto;
	top: 0;

	${({ theme, withPadding }) =>
		withPadding &&
		css`
			padding: 0 ${theme.general.padding.mobile}rem;

			${customMinResponsive(
				size.semi,
				css`
					padding: 0 4rem;
				`
			)};
		`}
`;

export const StyledCloseButton = styled(Button)`
	padding: 0;
`;

export const StyledText = styled.span`
	display: none;
	font-weight: ${({ theme }) => theme.font.normal};

	${customMinResponsive(
		size.semi,
		css`
			display: inline-block;
		`
	)};
`;
